// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P-FMv","footer":"styles_footer__2Zuqa"};